<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-tabs default-active-key="全部"
              v-model="query.status"
              @change="callback">
        <a-tab-pane key
                    tab="全部"></a-tab-pane>
        <a-tab-pane :key="0"
                    tab="未开始"></a-tab-pane>
        <a-tab-pane :key="1"
                    tab="执行中"></a-tab-pane>
        <a-tab-pane :key="2"
                    tab="已提交"></a-tab-pane>
        <a-tab-pane :key="3"
                    tab="已完成"></a-tab-pane>
      </a-tabs>
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="工单编号">
              <a-input v-model="query.workNo"
                       placeholder="请输入工单编号"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="工单类型">
              <a-select placeholder="请选择工单类型"
                        v-model="query.workOrderType"
                        allow-clear>
                <a-select-option v-for="item in OrderTypeList"
                                 :key="item.dictValue">{{
                  item.dictValue
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="工单内容">
              <a-input v-model="query.deviceName"
                       placeholder="请输入工单内容"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="负责人">
              <!-- <a-select show-search style="width: 200px" placeholder="请选择负责人" v-model="query.principal">
                <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
              </a-select> -->
              <a-input v-model="query.principalName"
                       placeholder="请输入负责人"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="9"
                 :sm="12">
            <a-form-item label="计划开始时间">
              <a-range-picker v-model="predictStimeA"
                              @change="onChanget" />
            </a-form-item>
          </a-col>
          <a-col :md="12"
                 :sm="12">
            <a-form-item label="开始时间">
              <a-range-picker v-model="startTimeS"
                              @change="onChangeh" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="PublishTask()"
                        v-action:add>新增</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="exportHandle()">导出</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()"
                        v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             bordered
             :scroll="{ x: 2100 }"
             :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             @change="pageChange">
      <template slot="action"
                slot-scope="text, record">
        <!-- <a style="margin-right: 5px" v-if="record.status == 0" @click="editHandle(record)">编辑</a> -->
        <a v-if="record.status != 1"
           style="margin-right: 5px"
           @click="details(record.id)">详情</a>

        <div v-if="record.status == 1">
          <a style="margin-right: 5px"
             @click="delay(record.id)">延期</a>
          <a style="margin-right: 5px"
             @click="UrgeHandle(record.id)">催办</a>
          <a style="margin-right: 5px"
             @click="ReassignHandle(record)">转派</a>
          <a style="margin-right: 5px"
             @click="details(record.id)">详情</a>
        </div>
      </template>
      <span slot="createTime"
            slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="predictStime"
            slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="predictEtime"
            slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <template slot="statusAction"
                slot-scope="text">
        <a-tag color="rgb(255, 99, 71)"
               v-if="text == 0">未开始</a-tag>
        <a-tag color="#f98303"
               v-if="text == 1">执行中</a-tag>
        <a-tag color="#40a9ff"
               v-if="text == 2">已提交</a-tag>
        <a-tag color="rgb(50, 205, 50)"
               v-if="text == 3">已完成</a-tag>
      </template>
    </a-table>
    <!-- 查看详情 -->
    <a-modal title="详情"
             :visible="visibles"
             style="top: 20px"
             :width="800"
             :destroyOnClose="true"
             :confirm-loading="confirmLoading"
             @cancel="handleCancelhr">
      <a-row style="margin-top: 20px">
        <a-col :span="12">关联事件：{{ Details.eventNo }}</a-col>
        <a-col :span="12">关联任务：{{ Details.taskNo }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">工单编号：{{ Details.workNo }}</a-col>
        <a-col :span="12">工单类型：{{ Details.workOrderType }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">工单来源：{{ Details.workOrderSource }}</a-col>
        <a-col :span="12">负责人：{{ Details.principalName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">协办人：{{ Details.assistPersonName }}</a-col>
        <a-col :span="12">督办人：{{ Details.maintainPersonName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">计划开始时间：<span v-if="Details.predictStime !== null">{{
            moment(Details.predictStime).format('YYYY-MM-DD')
          }}</span></a-col>
        <a-col :span="12">计划完成时间：<span v-if="Details.predictEtime !== null">{{
            moment(Details.predictEtime).format('YYYY-MM-DD')
          }}</span></a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">开始时间：<span v-if="Details.startTime !== null">{{ moment(Details.startTime).format('YYYY-MM-DD') }}</span>
        </a-col>
        <a-col :span="12">完成时间：<span v-if="Details.completeTime !== null">{{
            moment(Details.completeTime).format('YYYY-MM-DD')
          }}</span></a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">创建时间：{{ Details.createTime }}</a-col>
        <a-col :span="12">备注：{{ Details.remark }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">工单内容：{{ Details.deviceName }}</a-col>
        <a-col :span="12">状态：
          <a-tag color="rgb(255, 99, 71)"
                 v-if="Details.status == 0"
                 style="font-size: 14px">未开始</a-tag>
          <a-tag color="#f98303"
                 v-if="Details.status == 1"
                 style="font-size: 14px">执行中</a-tag>
          <a-tag color="#40a9ff"
                 v-if="Details.status == 2"
                 style="font-size: 14px">已提交</a-tag>
          <a-tag color="rgb(50, 205, 50)"
                 v-if="Details.status == 3"
                 style="font-size: 14px">已完成</a-tag>
        </a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="24">维修地点：<span @click="addAddres"
                style="color: rgb(44, 132, 248)">{{
            Details.maintainAddress
          }}</span></a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12"
               v-if="Details.status !== 1">处理结果：{{ Details.consequence }}</a-col>
        <a-col :span="12"
               v-if="Details.status !== 1">描述：{{ Details.noteContent }}</a-col>
        <a-col :span="12"
               v-if="Details.status == 1">处理结果：{{ Details.draftConsequence }}</a-col>
        <a-col :span="12"
               v-if="Details.status == 1">描述：{{ Details.draftNoteContent }}</a-col>
      </a-row>
      <div v-if="Details.isWaterOffEvent == 1">
        <a-row style="margin-top: 20px">
          <a-col :span="12">是否需要新增停水事件:<span v-if="Details.isWaterOffEvent == 1">是</span><span v-else>否</span></a-col>
          <a-col :span="12">是否关联停水事件:<span v-if="Details.isRelationWaterOffEvent == 1">是</span><span v-else>否</span></a-col>
        </a-row>
        <div v-if="Details.gisWaterEvent !== null">
          <a-row style="margin-top: 20px">
            <a-col :span="12">关联停水事件：{{ Details.gisWaterEvent.eventName + Details.gisWaterEvent.eventNo }}</a-col>
            <a-col :span="12">事件名称：{{ Details.gisWaterEvent.eventName }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">爆管管段：<a-button type="primary"
                        @click="openMap()">查看管道</a-button></a-col>
            <a-col :span="12">停水管理员：{{ Details.gisWaterEvent.waterAdminName }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">开始分类编码：{{ Details.gisWaterEvent.startClassNo }}</a-col>
            <a-col :span="12">结束分类编码：{{ Details.gisWaterEvent.endClassNo }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">计划停水开始时间：{{ Details.gisWaterEvent.planStartTime }}</a-col>
            <a-col :span="12">计划停水结束时间：{{ Details.gisWaterEvent.planEntTime }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">事件描述：{{ Details.gisWaterEvent.describe }}</a-col>
            <a-col :span="12"></a-col>
          </a-row>
        </div>
      </div>
      <a-row style="margin-top: 20px">
        <a-col :span="12">
          <div class="fileDiv">
            文件：
            <ul>
              <li class="fileLi"
                  v-for="item in fileNamestex"
                  :key="item.url">
                <div class="uploadDiv"
                     @click="uploadFile(item)">
                  <a-icon type="file-done"
                          style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <!-- <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" /> -->
              </li>
            </ul>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="fileDiv">
            图片：
            <ul>
              <li class="fileLi"
                  v-for="item in fileNamesimg"
                  :key="item.url">
                <img :src="item.url"
                     alt=""
                     style="width: 80px; height: 80px"
                     @click="clicimg(item.url)" />
              </li>
            </ul>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">
          <div class="fileDiv">
            完成图片：
            <ul v-if="Details.status == 3">
              <li class="fileLi"
                  v-for="item in Details.completeFileNames"
                  :key="item.url">
                <img :src="item.url"
                     alt=""
                     style="width: 80px; height: 80px"
                     @click="clicimg(item.url)" />
              </li>
            </ul>
            <ul v-else>
              <li class="fileLi"
                  v-for="item in Details.draftCompleteFileNames"
                  :key="item.url">
                <img :src="item.url"
                     alt=""
                     style="width: 80px; height: 80px"
                     @click="clicimg(item.url)" />
              </li>
            </ul>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="fileDiv">
            <!-- 草稿图片： -->
            <!-- <ul>
              <li class="fileLi" v-for="item in Details.draftCompleteFileNames" :key="item.url">
                <img :src="item.url" alt="" style="width: 80px; height: 80px" @click="clicimg(item.url)" />
              </li>
            </ul> -->
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">处理记录：
          <a-form-model-item style="margin-top: 16px"
                             label=""
                             :label-col="{ span: 3 }"
                             :wrapper-col="{ span: 20 }">
            <a-timeline>
              <a-timeline-item v-for="item in Details.records"
                               :key="item.id">
                <span>{{ item.createTime }}</span>
                <span style="color: blue; margin-left: 20px">{{ item.name }}</span>
                <span style="margin-left: 10px">{{ item.message }}</span>
              </a-timeline-item>
            </a-timeline>
          </a-form-model-item></a-col>
      </a-row>
      <template #footer>
        <a-button @click="handleCancelhr">取消</a-button>
      </template>
    </a-modal>
    <order-modal ref="OrderModal"
                 @handleOk="queryList"></order-modal>
    <a-modal title="图片"
             style="top: 20px"
             :width="800"
             :footer="null"
             :visible="visiblest"
             :confirm-loading="confirmLoading"
             @cancel="handleCancelhlg">
      <img :src="this.pumpUrlg"
           :alt="this.pumpUrlg"
           style="width: 100%; height: 100%" />
    </a-modal>
    <a-modal title="地图"
             style="top: 20px"
             :width="800"
             v-model="mapVisible"
             @ok="mapVisible = false"
             @cancel="mapVisible = false">
      <lonlat-map ref="lonlatMaps"
                  @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- 延期 -->
    <a-modal title="延期"
             style="top: 20px"
             :width="500"
             v-model="delayVisible"
             @ok="delayOk"
             @cancel="handleCancedelay">
      <a-form-model class="log-form"
                    :model="UpdateForm"
                    ref="UpdateForm"
                    :rules="rules"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 14 }">
        <a-form-model-item label="预计完成时间"
                           prop="predictEtime">
          <!-- <a-date-picker v-model="UpdateForm.predictEtime" @change="onChant" /> -->
          <a-date-picker v-model="UpdateForm.predictEtime"
                         :disabled-date="disabledStartDates"
                         @change="onChant" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal class="log-form"
             :title="'选取位置'"
             width="50%"
             v-model="showMap"
             @ok="closeMap"
             @cancel="closeMap2">
      <input class="login-input"
             type="text"
             v-model="startLine"
             placeholder="请输入开始分类编码" />
      <input class="login-input"
             type="text"
             v-model="endLine"
             placeholder="请输入结束分类编码" />
      <a-button type="submit"
                @click="searchMapLine">查询</a-button>
      <mapTemplate ref="waterMap"
                   v-on:childByValue="childByValue"></mapTemplate>
    </a-modal>
  </a-card>
</template>

<script>
import dayjs from 'dayjs'
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import OrderModal from './modules/OrderModal'
import LonlatMap from '../../maintenance/EventManagement/modules/lonlatMap.vue'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
import { treeMap } from 'ant-design-vue/es/table/util'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '工单编号',
    dataIndex: 'workNo',
    width: 200,
  },
  {
    title: '工单类型',
    dataIndex: 'workOrderType',
    width: 100,
  },
  {
    title: '工单来源',
    dataIndex: 'workOrderSource',
    width: 120,
  },
  {
    title: '工单内容',
    dataIndex: 'deviceName',
    width: 100,
    ellipsis: true,
  },
  //  {
  //   title: '设备编号',
  //   dataIndex: 'deviceNo',
  // },
  {
    title: '负责人',
    dataIndex: 'principalName',
    width: 120,
  },
  {
    title: '协办人',
    dataIndex: 'assistPersonName',
    width: 120,
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 120,
    scopedSlots: { customRender: 'statusAction' },
  },
  {
    title: '计划开始时间',
    dataIndex: 'predictStime',
    scopedSlots: { customRender: 'predictStime' },
    width: 200,
  },
  {
    title: '计划完成时间',
    dataIndex: 'predictEtime',
    scopedSlots: { customRender: 'predictEtime' },
    width: 200,
  },
  {
    title: '维修地点',
    dataIndex: 'maintainAddress',
    width: 200,
    ellipsis: true,
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    width: 200,
  },
  {
    title: '完成时间',
    dataIndex: 'completeTime',
    width: 200,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 200,
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 110,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    OrderModal,
    LonlatMap,
    mapTemplate,
    dayjs,
  },
  name: 'OrderManagement',
  data () {
    return {
      dayjs,
      startLine: '',
      endLine: '',
      startLines: '',
      endLines: '',
      showMap: false,
      delayVisible: false,
      currentId: '',
      queryUrl: '/pipe-network/work_order_managements/page',
      deleteUrl: '/pipe-network/work_order_managements',
      addOrUpdateUrl: '/pipe-network/inspection_tasks',
      queryOneUrl: '/pipe-network/work_order_managements',
      exportDataUrl: 'pipe-network/work_order_managements/export',
      exportFileName: '工单表.xlsx',
      visibles: false,
      visiblest: false,
      pumpUrlg: '',
      confirmLoading: false,
      mapVisible: false,
      Details: {},
      UpdateForm: {
        id: '',
        predictEtime: '',
      },
      query: {
        status: '',
        deviceName: '',
        workOrderType: '',
        // principal: '',
        sysType: '巡检',
        workNo: '',
        predictStime: '',
        predictEtime: '',
        startTime: '',
        endTime: '',
        principalName: '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
        sysType: '巡检',
      },
      fileNamesimg: [],
      fileNamestex: [],
      fileNames: [],
      statu: '',
      uploadUrl: process.env.VUE_APP_API_BASE_URL + 'manager/file/resources/upload',
      TaskList: [],
      eventTypeList: [],
      OrderTypeList: [], //工单类型
      predictStimeA: [],
      startTimeS: [],
      userlist: [], //负责人
    }
  },
  filters: {
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  computed: {
    rules () {
      return {
        predictEtime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
      }
    },
  },
  created () {
    this.getTaskList()
    this.getUserList()
    this.getOrderTypeList()
    this.resetList()
  },
  methods: {
    disabledStartDates (current) {
      return current && current < dayjs().endOf('day')
    },
    changeStartAndEnd (start, end) {
      this.startLine = start
      this.endLine = end
    },
    openMap (i) {
      this.showMap = true
      this.startLine = this.startLines || ''
      this.endLine = this.endLines || ''
      if (this.startLine.length > 0 || this.endLine.length > 0) {
        this.$nextTick(() => {
          this.$refs.waterMap.searchLines(this.startLine, this.endLine)
        })
      }
    },
    closeMap () {
      this.showMap = false
      this.Details.gisWaterEvent.startClassNo = this.startLine
      this.Details.gisWaterEvent.endClassNo = this.endLine
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2 () {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine () {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    childByValue (childValue) {
      if (childValue && childValue[0]) {
        this.startLine = childValue[0].properties?.start_class_no || ''
        this.endLine = childValue[0].properties?.end_class_no || ''
      }
    },
    moment,
    addAddres () {
      this.mapVisible = true
      if (this.Details.place) {
        var pointData = this.Details.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk () { },
    onChangeh (value, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
      console.log(this.query.startTime, '开始', this.query.endTime, '结束')
    },
    onChant (value, dateString) {
      console.log(dateString)
      this.UpdateForm.predictEtime = dateString + ' 00:00:00'
    },
    onChanget (value, dateString) {
      this.query.predictStime = dateString[0]
      this.query.predictEtime = dateString[1]
      console.log(this.query.predictStime, '开始', this.query.predictEtime, '结束')
    },
    getUserList () {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    uploadFile (item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    //缩略图
    clicimg (i) {
      this.pumpUrlg = i
      this.visiblest = true
    },
    handleCancelhlg () {
      this.visiblest = false
    },
    //查看详情
    details (id) {
      this.currentId = id
      this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then((res) => {
        this.Details = res.data
        this.fileNames = res.data.fileNames
        this.startLines = res.data.startClassNo
        this.endLines = res.data.endClassNo
        if (this.fileNames.length !== 0) {
          for (var i = 0; i < this.fileNames.length; i++) {
            var index = this.fileNames[i].url.lastIndexOf('.')
            var ext = this.fileNames[i].url.substr(index + 1)
            function isAssetTypeAnImage (ext) {
              return (
                ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
              )
            }
            if (isAssetTypeAnImage(ext) == true) {
              this.fileNamesimg.push(this.fileNames[i])
            } else {
              this.fileNamestex.push(this.fileNames[i])
            }
          }
        }
        this.visibles = true
      })
    },
    handleCancelhr () {
      ; (this.fileNamesimg = []), (this.fileNamestex = []), (this.visibles = false)
    },
    delayOk () {
      const _this = this
      let params = {
        id: this.UpdateForm.id,
        predictEtime: this.UpdateForm.predictEtime,
      }
      this.$refs.UpdateForm.validate((valid) => {
        if (valid) {
          this.$http.post('/pipe-network/work_order_managements/delay', params).then((res) => {
            if (res.code == 0) {
              this.$message.success(`延期成功`)
              this.$refs.UpdateForm.resetFields()
              this.queryList()
              this.delayVisible = false
            } else {
              this.$message.success(`延期失败！`)
              this.$refs.UpdateForm.resetFields()
              this.queryList()
              this.delayVisible = false
            }
          })
        }
      })
    },
    handleCancedelay () {
      this.$refs.UpdateForm.resetFields()
      this.delayVisible = false
    },
    delay (id) {
      this.UpdateForm.id = id
      this.delayVisible = true
    },
    UrgeHandle (id) {
      const _this = this
      this.$confirm({
        title: `催办提醒`,
        content: `您确认要催办本条数据吗?`,
        okText: '确认',
        okType: 'warrning',
        cancelText: '取消',
        onOk () {
          let params = {
            id: id,
          }
          _this.$http.post('/pipe-network/work_order_managements/urge', params).then(({ data }) => {
            _this.$message.success(`催办成功`)
            _this.queryList()
          })
        },
        onCancel () {
          _this.$message.info('已取消催办')
        },
      })
    },
    // deleteSelectRow(id) {
    //   const _this = this
    //   this.$confirm({
    //     title: `删除提醒`,
    //     content: `您确认要删除本条数据吗?`,
    //     okText: '确认',
    //     okType: 'danger',
    //     cancelText: '取消',
    //     onOk() {
    //       _this.$http
    //         .delete(_this.deleteUrl, { data: [id] })
    //         .then((res) => {
    //           if (res.code === 0) {
    //             _this.$message.success(`删除成功`)
    //             _this.queryList()
    //           }
    //         })
    //         .catch(() => {})
    //     },
    //     onCancel() {
    //       _this.$message.info('已取消删除')
    //     },
    //   })
    // },
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {

          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            this.selectedRows = []
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    resetList () {
      this.query = {
        workNo: '',
        status: this.statu,
        workOrderType: undefined,
        deviceName: '',
        deviceNo: '',
        maintainPerson: '',
        sysType: '巡检',
        principalName: '',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.predictStimeA = []
      this.startTimeS = []
      this.queryList()
    },
    callback (key) {
      this.statu = key
      console.log(key)
      if (key == '') {
        // this.query.status=''
      } else {
      }
      this.queryList()
    },
    getOrderTypeList () {
      const params = {
        dictCode: 'CHECKING-THE-REPAIR-ORDER',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.OrderTypeList = data
      })
    },
    PublishTask () {
      this.$refs.OrderModal.edit()
    },
    ReassignHandle (record) {
      this.$refs.OrderModal.ReassignHandle(record.id)
    },
    editHandle (record) {
      console.log(123)
      this.$refs.OrderModal.edit(record.id)
    },
    goDetails () { },
    selectChange (value) {
      this.addOrUpdateForm.accessorys = `${value}`
    },
    getTaskList () {
      const params = {
        dictCode: 'TASK_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {

        this.TaskList = data
      })
    },
    EndOnChange (date, dateString) {
      this.query.endTime = dateString
    },
    StartOnChange (date, dateString) {
      this.query.startTime = dateString
    },

    detailInfo (record) {
      this.detailForm = { ...record }
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    handleCancel () { },
    onOk (value) { },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
